<template>
<v-container fluid>
	<v-row class="my-2">
		<v-tabs v-model="tab" height="35"
			background-color="primary"
			hide-slider
			fixed-tabs
			dark>
			<v-tab :to="link(item)" ripple
				class="text-capitalize"
				v-for="item in items"
				:key="item">
				{{ item }}
			</v-tab>
		</v-tabs>
	</v-row>
	<!--get info
	<div class="ml-8">
		<v-form v-model="valid" ref="form" validation>
			<v-row class="my-2">
				<v-col cols="12" sm="4" md="2">
					<v-text-field dense
						color="secondary"
						v-model="gameId"
						label="game id"
						readonly
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="2" md="1">
					<v-select dense
						v-model.number="selected"
						:items="rounds"
						value="currentRound"
						color="secondary"
						item-color="primary"
						label="round"
						required
						:rules="numberRules">
					</v-select>
				</v-col>
				<v-col cols="12" sm="3" md="2" class="mt-4">
					<v-btn color="secondary" small dark
						class="text-lowercase"
						:disabled="!valid || Boolean(error)"
						@click="getInfo"
						>load
					</v-btn>	
				</v-col>
			</v-row>
		</v-form>
	</div>
	end form-->
	<v-row class="caption font-weight-bold">
		<span class="ml-4">company: {{company}}</span>
		<span class="ml-4">current round: {{currentRound}}</span>
		<span class="ml-4">year: {{currentYear}}</span>
	</v-row>
	<v-divider class="my-8"></v-divider>
		<v-tabs-items v-model="tab" continuous>
			<v-tab-item value="/customer/reports/trademarks">
				<trademarks
					:gameId="gameId"
					:round="currentRound"
				></trademarks>
			</v-tab-item>
			<v-tab-item value="/customer/reports/sales">
				<sales
					:company="company"
					:gameId="gameId"
					:round="currentRound">
				</sales>
			</v-tab-item>
			<v-tab-item value="/customer/reports/retailChannels">
				<retail-channels
					:company="company"
					:gameId="gameId"
					:round="currentRound">
				</retail-channels>
			</v-tab-item>
			<v-tab-item value="/customer/reports/segmentResults">
				<segment-results
					:company="company"
					:gameId="gameId"
					:round="currentRound">
				</segment-results>
			</v-tab-item>
			<v-tab-item :value="finPath">
				<financial-summary
					:company="company"
					:gameId="gameId"
					:round="currentRound"
				></financial-summary>
			</v-tab-item>
		</v-tabs-items>
	</v-container>
</template>
<script>
	import Trademarks from '../components/reports/company/Trademarks.vue'
	import Sales from '../components/reports/company/Sales.vue'
	import RetailChannels from '../components/reports/company/RetailChannels.vue'
	import SegmentResults from '../components/reports/company/SegmentResults.vue'
	import FinancialSummary from '../components/reports/company/FinancialSummary.vue'

	export default {
		data () {
			return {
				tab: 0,
				items: ['Trademarks','Sales','Retail channels','Segment results', 'Financial summary'],
				valid: false,
				error: '',
				selected: null,
				numberRules: [v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'],
			}
		},
		computed: {
			company () {
				return this.$store.getters.company
			},
			currentYear () {
				return this.$store.getters.currentYear
			},
			currentRound () {
				return this.$store.getters.currentRound
			},
			gameId () {
				return this.$store.getters.gameId
			},
			rounds () {
				const arr = []
				for (let i = 1; i < (this.currentRound + 1); i++) {
					arr.push(i)
				}
				return arr
			},
			round () {
				return this.selected
			},	
			finPath() {
				return `/customer/reports/financialSummary?company=${this.company}`
			}
		},
		methods: {
			link (item) {
				const item_arr = item.split(' ')
				const first = item_arr[0].toLowerCase()
				let second = ''
				if (item_arr.length > 1) {
					second = item_arr[1][0].toUpperCase() + item_arr[1].substr(1)
					
					if (second == 'Summary') {
						second += `?company=${this.company}`
					}
				}
				return `/customer/reports/${first + second}`
			},
			/* async getInfo () {
				
				if (this.$refs.form.validate()) {
					
					//console.log(obj)
					try {
						await this.$store.dispatch('fetchSummary', obj)
						await this.$store.dispatch('fetchAdjustedSales', obj)
						await this.$store.dispatch('fetchFranchisesStores', obj)
						await this.$store.dispatch('fetchChainTrademarks', obj)
					}
					catch (error) {
						this.error = error.message
					}
				}
			} */
		},
		async beforeCreated() {
			
			//if (this.currentRound && this.gameId) {
				
			const round = this.currentRound - 1; //last round
				
				const obj = {
					gameId: this.gameId,
					round: round
				}
				
				try {
					await this.$store.dispatch('fetchSummary', obj)
					await this.$store.dispatch('fetchAdjustedSales', obj)
					await this.$store.dispatch('fetchFranchisesStores', obj)
					await this.$store.dispatch('fetchChainTrademarks', obj)
				}
				catch (error) {
					this.error = error.message
				}
			//}
		},
		components: {
			Trademarks,
			Sales,
			RetailChannels,
			SegmentResults,
			FinancialSummary
		}
	}
</script>